<template>
  <section>
    <h3>404</h3>
  </section>
</template>

<script>
export default {}
</script>
